<template>
  <div 
    :id="identifier" 
    style="display: block; margin-left: auto; margin-right: auto; width: 50%; margin-top: 6px;" />
</template>

<script>
import Plotly from 'plotly.js-dist'
import random from 'lodash/random'

export default {
  props: {
    colors: {
      type: Array,
      default: () => ['yellow', 'red']
    },

    identifier: {
      type: String,
      default: () => `_${Math.random().toString(36).substr(2, 9)}`
    },

    labels: {
      type: Array,
      required: true
    },

    rotation: {
      type: Number,
      default: 0
    },

    values: {
      type: Array,
      required: true,
      default: () => [0, 100]
    },
  },

  data: () => ({
    chart: {
      configuration: {
        responsive: true,
        displayModeBar: false
      },

      layout: {
        height: 32,
        width: 32,
        paper_bgcolor: 'rgba(0,0,0,0)',
        plot_bgcolor: 'rgba(0,0,0,0)',
        showlegend: false,
        margin: {
          t: 0,
          b: 0,
          l: 0,
          r: 0,
          p: 0
        }
      }
    }
  }),

  mounted () {
    Plotly.newPlot(
      this.identifier,
      [{
        sort: false,
        direction: 'clockwise',
        rotation: this.rotation,
        values: this.values,
        labels: this.labels,
        marker: { colors: this.colors },
        type: 'pie',
        textinfo: 'none',
        hoverinfo: 'none'
      }],
      this.chart.layout,
      this.chart.configuration
    )
  }
}
</script>



// WEBPACK FOOTER //
// PieChart.vue?1f3122c2